<template>
    <label class="t_cell-select_label emul-check">
        <input type="checkbox" ref="item" class="t_cell-select_input" :checked="checked" @change="toggle"/>
        <span>
            <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path
                d="M1 4L4.5 7.5L11 1" stroke="#2C2A44" strokeWidth="2"></path></svg>
        </span>
    </label>
</template>

<script>
export default {
    name: "SelectCheckboxComponent",

    props: ['value', 'isChecked'],

    data: function () {
        return {
            checked: false,
        };
    },

    mounted() {
        this.$eventBus.$on('select-checkbox', (key, status) => {
            if (key == this.value) {
                this.toggle(null, status);
            }
        });
    },

    watch: {
        // whenever question changes, this function will run
        isChecked: function (newVal, oldVal) {
            this.checked = newVal
            if (newVal !== this.$refs.item.checked) {
                this.$refs.item.click();
            }
        }
    },

    methods: {
        toggle(event, status = null) {
            //console.log(event);
            //console.log(status);

            if (status !== null) {
                this.checked = status;
            } else {
                this.checked = event.target.checked
            }

            this.$emit('toggle', this.value, this.checked);
        },
    }
}
</script>

<style scoped>

</style>
